export const DEFAULT_ERROR_CODE = 'DEFAULT';
export const ERROR_CODE = [
    {
        code: DEFAULT_ERROR_CODE,
        popupClass: 'popup__icon--limit-number',
    },
    {
        code: 'Số tiền trong tài khoản của bạn không đủ',
        popupClass: 'popup__icon--not-enough-money',
        message: 'Số tiền trong tài khoản của bạn không đủ.',
    },
    {
        code: 'Requested fail to platform',
        popupClass: 'popup__icon--login',
        message: 'Phiên đăng nhập của bạn đã hết hạn, vui lòng đăng nhập lại.',
        redirectLink: process.env.VUE_APP_CLIENT_URL + '?action=login',
    },
    {
        code: 'Bạn chưa đăng nhập',
        popupClass: 'popup__icon--login',
        message:
            'Bạn cần đăng nhập để đặt cược. <br/> Bạn có muốn đến trang đăng nhập không?',
        inPageMsg: 'Bạn cần đang nhập để đặt cược.',
        redirectLink: process.env.VUE_APP_CLIENT_URL + '?action=login',
    },
    {
        code: 'Đài này sắp xổ không nhận cược',
        popupClass: 'popup__icon--lock-bet',
        message: 'Đài này sắp xổ không nhận cược.',
    },
];
